import React, { Fragment } from "react";
import IntlMessages from "Util/IntlMessages";
import {
  Row,
  Card,
  CardBody,
  NavItem,
  Button,
  Badge,
  Table,
  Input
} from "reactstrap";

import { Colxx, Separator } from "Components/CustomBootstrap";
import { BreadcrumbItems } from "Components/BreadcrumbContainer";
import { NavLink } from "react-router-dom";
import EmailsMenu from "Components/EmailsMenu";
import emailsData from "Data/emailsData.json";

import PerfectScrollbar from "react-perfect-scrollbar";

const emailsD = emailsData.data;

const EMAIL_SCROLL = { suppressScrollX: true, wheelPropagation: false };

function EmailsMon() {
  return (
    <Fragment>
        <Row>
          <Colxx xxs="12">
            <div className="mb-2">
              <h1>
                <IntlMessages id="menu.emails" />
              </h1>
              <BreadcrumbItems />
            </div>

            <Separator className="mb-5" />

            <Row>
              <Colxx xl="4" xxs="1" lg="1" md="1">
                <EmailsMenu>
                  <PerfectScrollbar option={EMAIL_SCROLL}>
                    <div className="p-4">
                      <Button
                        href="/app/mails/compose-mails"
                        color="primary"
                        size="lg"
                        className="mt-3 mb-5"
                      >
                        <IntlMessages id="emails.compose-email" />
                      </Button>
                      <ul className="list-unstyled mb-5">
                        <NavItem className="my-3">
                          <NavLink to="#">
                            <i className="far fa-envelope" />
                            <IntlMessages id="emails.inbox" />
                            <span className="float-right">
                              <Badge color="primary">23</Badge>
                            </span>
                          </NavLink>
                        </NavItem>
                        <NavItem className="my-3">
                          <NavLink to="#">
                            <i className="far fa-file" />
                            <IntlMessages id="emails.draft" />
                          </NavLink>
                        </NavItem>
                        <NavItem className="my-3">
                          <NavLink to="#">
                            <i className="fa fa-exchange-alt" />
                            <IntlMessages id="emails.sent" />
                          </NavLink>
                        </NavItem>
                        <NavItem className="my-3">
                          <NavLink to="#">
                            <i className="fab fa-gripfire" />
                            <IntlMessages id="emails.spam" />
                          </NavLink>
                        </NavItem>
                        <NavItem className="my-3">
                          <NavLink to="#">
                            <i className="far fa-trash-alt" />
                            <IntlMessages id="emails.trash" />
                            <span className="float-right">
                              <Badge color="danger">4</Badge>
                            </span>
                          </NavLink>
                        </NavItem>
                        <Separator className="my-5" />
                        <NavItem className="my-3">
                          <NavLink to="#">
                            <i className="far fa-address-book" />
                            <IntlMessages id="emails.address-book" />
                          </NavLink>
                        </NavItem>
                        <NavItem className="my-3">
                          <NavLink to="#">
                            <i className="far fa-folder" />
                            <IntlMessages id="emails.user-folders" />
                          </NavLink>
                        </NavItem>
                        <Separator className="mt-5 mb-3" />
                        <strong>
                          Friends{" "}
                          <span className="float-right">
                            <Badge>New</Badge>
                          </span>
                        </strong>
                        <NavItem className="my-3">
                          <NavLink to="#">
                            <i className="far fa-circle font-color-1" />
                            Joey K. Greyson
                          </NavLink>
                        </NavItem>
                        <NavItem className="my-3">
                          <NavLink to="#">
                            <i className="far fa-circle font-color-2" />
                            Andrea Branden
                          </NavLink>
                        </NavItem>
                        <NavItem className="my-3">
                          <NavLink to="#">
                            <i className="far fa-circle font-color-3" />
                            Lucy Moon
                          </NavLink>
                        </NavItem>
                        <NavItem className="my-3">
                          <NavLink to="#">
                            <i className="far fa-circle font-color-4" />
                            Johny Juan
                          </NavLink>
                        </NavItem>
                        <NavItem className="my-3">
                          <NavLink to="#">
                            <i className="far fa-circle font-color-5" />
                            Susan Sun
                          </NavLink>
                        </NavItem>
                        <Separator className="mt-5 mb-3" />
                        <strong>Labels </strong>
                        <p className="mt-3">
                          <NavLink to="#">
                            <Badge color="light" className="text-dark">
                              <i className="fa fa-tags" /> Family
                            </Badge>{" "}
                          </NavLink>
                          <NavLink to="#">
                            <Badge
                              color="light"
                              className="mx-1 my-1 text-dark"
                            >
                              <i className="fa fa-tags" /> Home
                            </Badge>{" "}
                          </NavLink>
                          <NavLink to="#">
                            <Badge
                              color="light"
                              className="mx-1 my-1 text-dark"
                            >
                              <i className="fa fa-tags" /> Work
                            </Badge>
                          </NavLink>
                          <NavLink to="#">
                            <Badge
                              color="light"
                              className="mx-1 my-1 text-dark"
                            >
                              <i className="fa fa-tags" /> Film
                            </Badge>
                          </NavLink>
                          <NavLink to="#">
                            <Badge
                              color="light"
                              className="mx-1 my-1 text-dark"
                            >
                              <i className="fa fa-tags" /> Music
                            </Badge>
                          </NavLink>
                          <NavLink to="#">
                            <Badge
                              color="light"
                              className="mx-1 my-1 text-dark"
                            >
                              <i className="fa fa-tags" /> Photography
                            </Badge>
                          </NavLink>
                        </p>
                      </ul>
                    </div>
                  </PerfectScrollbar>
                </EmailsMenu>
              </Colxx>
              <Colxx className="ms-auto" xxs="11" lg="11" xl="8" md="11">
                <div>
                  <Card>
                    <CardBody>
                      <h3>
                        <IntlMessages id="emails.inbox" />
                        <span className="ms-1">(23)</span>
                      </h3>
                      <Table className="mt-3" borderless hover>
                        <tbody>
                          {emailsD.map((email, index) => {
                            return (
                              <tr key={index}>
                                <th>
                                  <Input
                                    type="checkbox"
                                    id={`selectEmail-${index}`}
                                  />
                                </th>
                                <td>
                                  <span className={`${email.star}`} />
                                </td>
                                <th>{email.sendersName}</th>
                                <td>
                                  <Badge color={`${email.labelColor}`}>
                                    {email.type}
                                  </Badge>{" "}
                                  {email.emailDesc}
                                </td>
                                <td>
                                  <span className={`${email.attachments}`} />
                                </td>
                                <td>{email.dateTime}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                    </CardBody>
                  </Card>
                </div>
              </Colxx>
            </Row>
          </Colxx>
        </Row>
      </Fragment>
  );
}

export default EmailsMon;
